import styled from "styled-components";
import { tags } from "@sablier/v2-constants";
import { _ } from "@sablier/v2-mixins";
import { SearchFromProvider as Provider } from "~/client/contexts";
import Footer from "../Footer";
import Form from "../Form";

const WrapperPartial = styled.div`
  flex: 1;
  flex-shrink: 0;
  width: 100%;
`;

const Content = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    flex-shrink: 0;
    row-gap: calc(${(props) => props.theme.sizes.edge} * 2);
    width: 100%;
    height: 100%;
    padding-inline: ${(props) => props.theme.sizes.modalEdge};
    padding-top: ${(props) => props.theme.sizes.edge};
    padding-bottom: calc(${(props) => props.theme.sizes.edge} * 2);
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    ${Content} {
      row-gap: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
      padding: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    }
  }
  ${(props) => props.theme.medias.maxSM} {
    ${Content} {
      row-gap: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
      padding-inline: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
      padding-bottom: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    }
  }
`;

function Body() {
  return (
    <Provider>
      <Wrapper data-cy={tags.modalSearch}>
        <Content>
          <Form />
        </Content>
      </Wrapper>
      <Footer />
    </Provider>
  );
}

export default Body;
